import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";

export const enum fields {}

export interface OwnProps extends WidgetProps {
    fields: {};
}

const mapStateToProps = (_: ApplicationState, __: OwnProps) => ({});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface BlogLandingWrapperWidgetStyles {
    wrapper?: InjectableCss;
}

export const blogLandingWrapperWidgetStyles: BlogLandingWrapperWidgetStyles = {};

const styles = blogLandingWrapperWidgetStyles;

const BlogLandingWrapperWidget = ({ id }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone contentId={id as never} zoneName={"MainContent" as never} requireRows={true as never} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogLandingWrapperWidget) as any,
    definition: {
        displayName: "Landing Wrapper",
        group: "Verndale Box - Blog" as any,
        icon: "blog",
        allowedContexts: ["BlogLandingPage" as any],
    },
};

export default widgetModule;
